import { render, staticRenderFns } from "./archived.vue?vue&type=template&id=4b957b3c&scoped=true"
import script from "./archived.vue?vue&type=script&lang=js"
export * from "./archived.vue?vue&type=script&lang=js"
import style0 from "./archived.vue?vue&type=style&index=0&id=4b957b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b957b3c",
  null
  
)

export default component.exports